import { EntityWorkflowEvaluator_BasicFilterSensitiveLog, } from "./models_0";
import { EntityRepositoryEvaluator_BasicFilterSensitiveLog, } from "./models_1";
export const AddQuestionToQuestionList2RequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const QuestionList2QuestionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AddQuestionToQuestionList2ResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateQuestionList2RequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var QuestionList2Constant;
(function (QuestionList2Constant) {
    QuestionList2Constant["ENTITY_TYPE"] = "questionList2";
})(QuestionList2Constant || (QuestionList2Constant = {}));
export const QuestionList2FilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateQuestionList2ResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteQuestionsFromQuestionList2RequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteQuestionsFromQuestionList2ResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetQuestionList2RequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetQuestionList2ResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetQuestionList2QuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetQuestionList2QuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexQuestionList2RequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchQuestionList2RequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const QuestionList2SearchItemFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchQuestionList2ResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateQuestionList2RequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateQuestionList2ResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateQuestionList2QuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateQuestionList2QuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var ItemContributorRole;
(function (ItemContributorRole) {
    ItemContributorRole["ENGINEER"] = "Engineer";
    ItemContributorRole["GENERAL_MANAGER"] = "General Manager";
    ItemContributorRole["PROJECT_MANAGER"] = "Project Manager";
    ItemContributorRole["SOFTWARE_DEVELOPMENT_MANAGER"] = "Software Development Manager";
    ItemContributorRole["TECHNICAL_PROJECT_MANAGER"] = "Technical Project Manager";
})(ItemContributorRole || (ItemContributorRole = {}));
export const ItemContributorFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateRapiniItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var RapiniItemConstant;
(function (RapiniItemConstant) {
    RapiniItemConstant["TYPE"] = "RapiniItem";
})(RapiniItemConstant || (RapiniItemConstant = {}));
export const RapiniEventDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var RapiniEventType;
(function (RapiniEventType) {
    RapiniEventType["ITEM_CREATED"] = "item_created";
    RapiniEventType["TASK_STATUS_CHANGED"] = "task_status_changed";
})(RapiniEventType || (RapiniEventType = {}));
export const RapiniEventFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RapiniItemInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateRapiniItemResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteRapiniItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EditRapiniItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EditRapiniItemResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetRapiniItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetRapiniItemResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexRapiniItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PublishRapiniEventRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchRapiniItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ALMProductContactFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RapiniSearchItemFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchRapiniItemResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UnindexRapiniItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const QuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const QuestionnaireResponsesFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AnswerRapiniItemReviewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var RapiniItemReviewConstant;
(function (RapiniItemReviewConstant) {
    RapiniItemReviewConstant["TYPE"] = "RapiniItemReview";
})(RapiniItemReviewConstant || (RapiniItemReviewConstant = {}));
export var RapiniAttachmentType;
(function (RapiniAttachmentType) {
    RapiniAttachmentType["DPIA"] = "DPIA";
    RapiniAttachmentType["OTHER"] = "OTHER";
    RapiniAttachmentType["ROPA"] = "ROPA";
})(RapiniAttachmentType || (RapiniAttachmentType = {}));
export const RapiniAttachmentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PrivacyDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var ReviewStatus;
(function (ReviewStatus) {
    ReviewStatus["APPROVED"] = "APPROVED";
    ReviewStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ReviewStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
})(ReviewStatus || (ReviewStatus = {}));
export const RapiniItemReviewInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AnswerRapiniItemReviewResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ApproveRapiniItemReviewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ApproveRapiniItemReviewResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateRapiniItemReviewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateRapiniItemReviewResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateTasksRapiniItemReviewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DownloadRapiniAttachmentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DownloadRapiniAttachmentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetRapiniItemReviewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetRapiniItemReviewResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexRapiniItemReviewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchRapiniItemReviewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RapiniItemReviewSearchDocumentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchRapiniItemReviewResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SubmitRapiniItemReviewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SubmitRapiniItemReviewResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateRapiniItemReviewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateRapiniItemReviewResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AttachFileRapiniItemReviewTaskRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var RapiniItemReviewTaskConstant;
(function (RapiniItemReviewTaskConstant) {
    RapiniItemReviewTaskConstant["TYPE"] = "RapiniItemReviewTask";
})(RapiniItemReviewTaskConstant || (RapiniItemReviewTaskConstant = {}));
export const TaskCommentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var ReviewTaskStatus;
(function (ReviewTaskStatus) {
    ReviewTaskStatus["CANCELLED"] = "CANCELLED";
    ReviewTaskStatus["COMPLETE"] = "COMPLETE";
    ReviewTaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
})(ReviewTaskStatus || (ReviewTaskStatus = {}));
export var RapiniTaskActionType;
(function (RapiniTaskActionType) {
    RapiniTaskActionType["CONFIRM"] = "Confirm";
    RapiniTaskActionType["FREE_TEXT_RESPONSE"] = "Free text response";
    RapiniTaskActionType["ONBOARD_TO_DSARS"] = "Onboard to DSARS";
    RapiniTaskActionType["OTHER"] = "Other";
    RapiniTaskActionType["UPLOAD_DPIA"] = "Upload DPIA";
    RapiniTaskActionType["UPLOAD_OTHER_DOCUMENT"] = "Upload other document";
    RapiniTaskActionType["UPLOAD_ROPA"] = "Upload ROPA";
})(RapiniTaskActionType || (RapiniTaskActionType = {}));
export var RapiniTaskRecipientType;
(function (RapiniTaskRecipientType) {
    RapiniTaskRecipientType["AWS_PRIVACY_LAWYER"] = "AWS Privacy Lawyer";
    RapiniTaskRecipientType["BUSINESS_LINE_LAWYER"] = "Business Line Lawyer";
    RapiniTaskRecipientType["PRODUCT_MANAGER"] = "Product Manager";
})(RapiniTaskRecipientType || (RapiniTaskRecipientType = {}));
export var ReviewTaskType;
(function (ReviewTaskType) {
    ReviewTaskType["AUTOMATED"] = "AUTOMATED";
    ReviewTaskType["MANUAL"] = "MANUAL";
})(ReviewTaskType || (ReviewTaskType = {}));
export const RapiniItemReviewTaskInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AttachFileRapiniItemReviewTaskResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CommentRapiniItemReviewTaskRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CommentRapiniItemReviewTaskResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateRapiniItemReviewTaskRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateRapiniItemReviewTaskResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetRapiniItemReviewTaskRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetRapiniItemReviewTaskResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexRapiniItemReviewTaskRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchRapiniItemReviewTaskRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RapiniItemReviewTaskSearchDocumentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchRapiniItemReviewTaskResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateRapiniItemReviewTaskRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateRapiniItemReviewTaskResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BatchGetRapiniQuestionDownloadUrlsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RapiniAnswerOptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var AnswerType;
(function (AnswerType) {
    AnswerType["FREE_TEXT"] = "FREE_TEXT";
    AnswerType["NO_ANSWER"] = "NO_ANSWER";
    AnswerType["SINGLE_SELECT"] = "SINGLE_SELECT";
})(AnswerType || (AnswerType = {}));
export const RapiniQuestionPayloadFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RapiniQuestionNodeFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RapiniQuestionDownloadResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BatchGetRapiniQuestionDownloadUrlsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RapiniQuestionNodeIdSandboxUrlFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateRapiniQuestionTreeRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var RapiniQuestionTreeConstant;
(function (RapiniQuestionTreeConstant) {
    RapiniQuestionTreeConstant["TYPE"] = "RapiniQuestionTree";
})(RapiniQuestionTreeConstant || (RapiniQuestionTreeConstant = {}));
export const RapiniQuestionTreeInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateRapiniQuestionTreeResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetRapiniQuestionTreeRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetRapiniQuestionTreeResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AddSubTopicRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SubtopicFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AddSubTopicResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateTopicRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var TopicConstant;
(function (TopicConstant) {
    TopicConstant["TYPE"] = "Topic";
})(TopicConstant || (TopicConstant = {}));
export const TopicInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateTopicResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetTopicRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetTopicResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexTopicRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchTopicRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchTopicResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateTopicRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateTopicResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TrackUserActivityRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var UserActivityConstant;
(function (UserActivityConstant) {
    UserActivityConstant["TYPE"] = "SDSUserActivity";
})(UserActivityConstant || (UserActivityConstant = {}));
export const UserActivityRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UserActivityInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TrackUserActivityResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var EntityWorkflowEvaluator;
(function (EntityWorkflowEvaluator) {
    EntityWorkflowEvaluator.visit = (value, visitor) => {
        if (value.basic !== undefined)
            return visitor.basic(value.basic);
        if (value.composite !== undefined)
            return visitor.composite(value.composite);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(EntityWorkflowEvaluator || (EntityWorkflowEvaluator = {}));
export const EntityWorkflowEvaluatorFilterSensitiveLog = (obj) => {
    if (obj.basic !== undefined)
        return { basic: EntityWorkflowEvaluator_BasicFilterSensitiveLog(obj.basic)
        };
    if (obj.composite !== undefined)
        return { composite: EntityWorkflowEvaluator_CompositeFilterSensitiveLog(obj.composite)
        };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: 'UNKNOWN' };
};
export const EntityWorkflowEvaluator_CompositeFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.evaluators && { evaluators: obj.evaluators.map(item => EntityWorkflowEvaluatorFilterSensitiveLog(item))
    }),
});
export const EntityRepositoryEvaluator_CompositeFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.evaluators && { evaluators: obj.evaluators.map(item => EntityRepositoryWorkflowEvaluatorFilterSensitiveLog(item))
    }),
});
export var EntityRepositoryWorkflowEvaluator;
(function (EntityRepositoryWorkflowEvaluator) {
    EntityRepositoryWorkflowEvaluator.visit = (value, visitor) => {
        if (value.basic !== undefined)
            return visitor.basic(value.basic);
        if (value.composite !== undefined)
            return visitor.composite(value.composite);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(EntityRepositoryWorkflowEvaluator || (EntityRepositoryWorkflowEvaluator = {}));
export const EntityRepositoryWorkflowEvaluatorFilterSensitiveLog = (obj) => {
    if (obj.basic !== undefined)
        return { basic: EntityRepositoryEvaluator_BasicFilterSensitiveLog(obj.basic)
        };
    if (obj.composite !== undefined)
        return { composite: EntityRepositoryEvaluator_CompositeFilterSensitiveLog(obj.composite)
        };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: 'UNKNOWN' };
};
export const CreateAdvancedListWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.evaluator && { evaluator: EntityWorkflowEvaluatorFilterSensitiveLog(obj.evaluator)
    }),
});
export const UpdateAdvancedListWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.evaluator && { evaluator: EntityWorkflowEvaluatorFilterSensitiveLog(obj.evaluator)
    }),
});
export const EntityWorkflowFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.evaluator && { evaluator: EntityWorkflowEvaluatorFilterSensitiveLog(obj.evaluator)
    }),
});
export const CreateMatterInstanceWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.evaluator && { evaluator: EntityRepositoryWorkflowEvaluatorFilterSensitiveLog(obj.evaluator)
    }),
});
export const MatterInstanceWorkflowFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.evaluator && { evaluator: EntityRepositoryWorkflowEvaluatorFilterSensitiveLog(obj.evaluator)
    }),
});
export const UpdateMatterInstanceWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.evaluator && { evaluator: EntityRepositoryWorkflowEvaluatorFilterSensitiveLog(obj.evaluator)
    }),
});
export const AdvancedListWorkflowContextFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.workflow && { workflow: EntityWorkflowFilterSensitiveLog(obj.workflow)
    }),
});
export const CreateAdvancedListWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: EntityWorkflowFilterSensitiveLog(obj.body)
    }),
});
export const UpdateAdvancedListWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: EntityWorkflowFilterSensitiveLog(obj.body)
    }),
});
export const CreateMatterInstanceWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: MatterInstanceWorkflowFilterSensitiveLog(obj.body)
    }),
});
export const CreateMatterOwnerInactiveWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: MatterInstanceWorkflowFilterSensitiveLog(obj.body)
    }),
});
export const CreateMatterRefreshWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: MatterInstanceWorkflowFilterSensitiveLog(obj.body)
    }),
});
export const MatterInstanceWorkflowContextFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.workflow && { workflow: MatterInstanceWorkflowFilterSensitiveLog(obj.workflow)
    }),
});
export const UpdateMatterInstanceWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: MatterInstanceWorkflowFilterSensitiveLog(obj.body)
    }),
});
export const ActAdvancedListWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.workflowContext && { workflowContext: AdvancedListWorkflowContextFilterSensitiveLog(obj.workflowContext)
    }),
});
export const BuildAdvancedListWorkflowContextResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.workflowContext && { workflowContext: AdvancedListWorkflowContextFilterSensitiveLog(obj.workflowContext)
    }),
});
export const EvaluateAdvancedListWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.workflowContext && { workflowContext: AdvancedListWorkflowContextFilterSensitiveLog(obj.workflowContext)
    }),
});
export const LoadAdvancedListWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: obj.body.map(item => EntityWorkflowFilterSensitiveLog(item))
    }),
});
export const ActMatterInstanceWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.workflowContext && { workflowContext: MatterInstanceWorkflowContextFilterSensitiveLog(obj.workflowContext)
    }),
});
export const BuildMatterInstanceWorkflowContextResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.workflowContext && { workflowContext: MatterInstanceWorkflowContextFilterSensitiveLog(obj.workflowContext)
    }),
});
export const EvaluateMatterInstanceWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.workflowContext && { workflowContext: MatterInstanceWorkflowContextFilterSensitiveLog(obj.workflowContext)
    }),
});
export const LoadMatterInstanceWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: obj.body.map(item => MatterInstanceWorkflowFilterSensitiveLog(item))
    }),
});
export const SearchMatterInstanceWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.items && { items: obj.items.map(item => MatterInstanceWorkflowFilterSensitiveLog(item))
    }),
});
